// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"e7f8f808","734":"8ea67787","941":"d922db5c"}[chunkId] + ".chunk.css";
};